import { DOCUMENT } from '@angular/common';
import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs';
import { AnalyticsService } from 'src/app/@services/analytics.service';
import { MixpanelService } from 'src/app/@services/mixpanel.service';

export function appRouteTrackingInitializer(): () => void {
  return (): void => {
    const router = inject(Router);
    const analyticsService = inject(AnalyticsService);
    const mixpanelService = inject(MixpanelService);
    const destroyRef = inject(DestroyRef);
    const documentRef = inject(DOCUMENT);

    router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        ),
        tap((event: NavigationEnd) => {
          analyticsService.trackPageView(
            event.urlAfterRedirects,
            documentRef.title
          );
          mixpanelService.trackPageView(
            event.urlAfterRedirects,
            documentRef.title
          );
        }),
        takeUntilDestroyed(destroyRef)
      )
      .subscribe();
  };
}
